export const shadeColor = (color = '#00000', percent) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  const RR =
    R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG =
    G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB =
    B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

export const desaturateColor = (color = '#00000', percent) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  // let M = (R + G + B) / 3;
  const M = 200;

  R = parseInt(R - ((R - M) * percent) / 100);
  G = parseInt(G - ((G - M) * percent) / 100);
  B = parseInt(B - ((B - M) * percent) / 100);

  const RR =
    R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG =
    G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB =
    B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

export const hexToRgba = (hex, opacity = 1) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
        result[3],
        16
      )}, ${opacity})`
    : null;
};

export const generateColorPalette = (
  steps = 2,
  color1 = '#0077CE',
  color2 = '#B2E5FF'
) => {
  if (steps === 1) return [color1];
  const colorPalette = [];

  // Converte i colori da esadecimale a RGB
  const r1 = parseInt(color1.slice(1, 3), 16);
  const g1 = parseInt(color1.slice(3, 5), 16);
  const b1 = parseInt(color1.slice(5, 7), 16);

  const r2 = parseInt(color2.slice(1, 3), 16);
  const g2 = parseInt(color2.slice(3, 5), 16);
  const b2 = parseInt(color2.slice(5, 7), 16);

  // Calcola le differenze tra i canali di colore
  const rStep = (r2 - r1) / (steps - 1);
  const gStep = (g2 - g1) / (steps - 1);
  const bStep = (b2 - b1) / (steps - 1);

  // Genera la palette di colori
  for (let i = 0; i < steps; i++) {
    const r = Math.round(r1 + i * rStep);
    const g = Math.round(g1 + i * gStep);
    const b = Math.round(b1 + i * bStep);

    // Converti il colore RGB in esadecimale
    const RR =
      r.toString(16).length === 1 ? `0${r.toString(16)}` : r.toString(16);
    const GG =
      g.toString(16).length === 1 ? `0${g.toString(16)}` : g.toString(16);
    const BB =
      b.toString(16).length === 1 ? `0${b.toString(16)}` : b.toString(16);
    const hexColor = `#${RR}${GG}${BB}`;

    colorPalette.push(hexColor);
  }

  return colorPalette;
};
